export default __webpack_public_path__ + "static/media/stars.319852ea.png";